import { useMemo } from 'react';
import { useTranslation } from '../../contexts/translation';
export const useFormLocalization = () => {
    const { translationByKey: t, currentLocale } = useTranslation('form');
    const localization = useMemo(() => {
        return {
            errorHeading: t('errorHeading', 'Error.'),
            locale: currentLocale,
        };
    }, [t, currentLocale]);
    return { localization };
};
